(function () {
  let lastVariantId = null;
  let lastProductId = null;
  let lastCategoryIds = "";

  let pending = [];

  function sdkEvents() {
    return (
      window.wunderkind && window.wunderkind.sdk && window.wunderkind.sdk.events
    );
  }

  function deliver(eventName, payload) {
    try {
      const result = sdkEvents()[eventName](payload);
      if (result && typeof result.catch === "function") {
        result.catch(function (err) {
          console.warn(
            "[WK] " + eventName + " rejected inside the Wunderkind SDK",
            err,
          );
        });
      }
    } catch (err) {
      console.warn(
        "[WK] " + eventName + " threw inside the Wunderkind SDK",
        err,
      );
    }
  }

  function flushPending() {
    const queue = pending.slice();
    pending = [];
    queue.forEach(function (item) {
      deliver(item.event, item.payload);
    });
  }

  function send(eventName, payload) {
    const events = sdkEvents();
    if (events && typeof events[eventName] === "function") {
      deliver(eventName, payload);
      return;
    }
    pending.push({ event: eventName, payload: payload });
  }

  function watchForSdk() {
    if (sdkEvents()) return flushPending();

    window.addEventListener("onWunderkindWebSDKLoaded", flushPending, {
      once: true,
    });

    // The load event can fire before this script binds, so poll as well.
    let attempts = 0;
    const poll = setInterval(function () {
      if (sdkEvents()) {
        clearInterval(poll);
        flushPending();
      } else if (++attempts > 40) {
        clearInterval(poll);
        if (!pending.length) return;
        try {
          let stored = JSON.parse(
            localStorage.getItem("wknd_web_sdk_preloaded_events"),
          );
          if (Object.prototype.toString.call(stored) !== "[object Array]")
            stored = [];
          pending.forEach(function (item) {
            stored.push({ eventName: item.event, payload: item.payload });
          });
          localStorage.setItem(
            "wknd_web_sdk_preloaded_events",
            JSON.stringify(stored),
          );
          pending = [];
        } catch (err) {}
      }
    }, 250);
  }

  function pageData() {
    const el = document.querySelector("[data-wunderkind-data]");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      console.error("[WK] could not parse the wunderkind-data snippet", err);
      return null;
    }
  }

  function absoluteUrl(url) {
    if (!url) return "";
    if (url.indexOf("//") === 0) return window.location.protocol + url;
    if (url.indexOf("/") === 0) return window.location.origin + url;
    return url;
  }

  function itemPayloadFromProduct(p) {
    if (!p || !p.id) return null;
    return {
      id: String(p.id),
      copy: String(p.title || "")
        .split("|")[0]
        .trim(),
      category: p.type || "",
      url: absoluteUrl(p.url || "/products/" + (p.handle || "")),
      imageurl: absoluteUrl(
        p.featured_image || (p.images && p.images[0]) || "",
      ),
      instock: !!p.available,
    };
  }

  function trackProductView(item) {
    if (!item) return;
    lastProductId = String(item.id);
    send("item", item);
    send("viewItem", { "item:id": item.id, "item:itemgroupid": item.id });
  }

  function trackVariant(productId, variantId) {
    if (!productId || !variantId) return;
    if (String(variantId) === String(lastVariantId)) return;
    lastVariantId = String(variantId);
    send("selectItem", {
      "item:id": String(productId),
      "item:itemgroupid": String(productId),
      "item:feedid": String(variantId),
    });
  }

  function productGrid() {
    return (
      document.getElementById("product-grid-section") ||
      document.querySelector(".main-collection__grid")
    );
  }

  function gridProductIds() {
    const grid = productGrid();
    if (!grid) return [];
    return [].slice
      .call(grid.querySelectorAll("[data-product-id]"))
      .map(function (el) {
        return el.getAttribute("data-product-id");
      });
  }

  function trackCategory(ids, url) {
    if (!ids || !ids.length) return;
    const key = ids.join(",");
    if (key === lastCategoryIds) return;
    lastCategoryIds = key;
    send("viewCategory", {
      "items:ids": ids,
      "page:url": url || window.location.href.split("?")[0],
    });
  }

  // Wunderkind only wants emptyCart when a cart that held items is cleared, so
  // track the count and compare. /cart/change|update|clear return the whole cart.
  let cartCount = 0;

  function handleCartMutation(body) {
    if (!body || typeof body.item_count !== "number") return;
    const previous = cartCount;
    cartCount = body.item_count;
    if (previous > 0 && cartCount === 0) send("emptyCart", {});
  }

  // change/update/clear return the cart, and the mini-cart refetches /cart.js on
  // refresh, so both keep the count in sync.
  function isCartMutationUrl(url) {
    return (
      typeof url === "string" &&
      /\/cart\/(change|update|clear)|\/cart\.js/.test(url)
    );
  }

  // The product form adds via jQuery, quick-buy and pair-with via fetch. Reading the
  // /cart/add response covers both and carries product_id.
  function handleCartAddResponse(body) {
    let items = [];
    if (!body) return;
    if (Object.prototype.toString.call(body.items) === "[object Array]")
      items = body.items;
    else if (body.id || body.product_id) items = [body];

    items.forEach(function (line) {
      if (line && line.properties && line.properties._gwp) return;
      const productId = line && (line.product_id || line.id);
      if (!productId) return;
      cartCount += line.quantity || 1;
      send("addToCart", { "item:id": String(productId) });
    });
  }

  function isCartAddUrl(url) {
    return typeof url === "string" && url.indexOf("/cart/add") !== -1;
  }

  if (window.fetch) {
    const originalFetch = window.fetch;
    window.fetch = function () {
      const args = arguments;
      return originalFetch.apply(this, args).then(function (response) {
        try {
          const url = (args[0] && args[0].url) || args[0];
          if (response.ok && (isCartAddUrl(url) || isCartMutationUrl(url))) {
            const handler = isCartAddUrl(url)
              ? handleCartAddResponse
              : handleCartMutation;
            response
              .clone()
              .json()
              .then(handler)
              .catch(function () {});
          }
        } catch (err) {}
        return response;
      });
    };
  }

  function init() {
    const data = pageData();
    if (!data) return;

    watchForSdk();

    cartCount = data.cartCount || 0;

    if (data.customerEmail) send("logIn", { email: data.customerEmail });

    if (data.pageType === "product" && data.product) {
      const p = data.product;
      trackProductView({
        id: p.id,
        copy: p.copy,
        category: p.category,
        url: p.url,
        imageurl: absoluteUrl(p.imageurl),
        instock: p.instock,
      });
      trackVariant(p.id, p.variantId);
    }

    if (data.pageType === "collection" && data.collection) {
      trackCategory(gridProductIds(), data.collection.url);
    }

    // Wunderkind's docs say to use viewCategory for search unless a separate
    // search abandonment series is set up. Keep the query so the results resolve.
    if (data.pageType === "search") {
      trackCategory(gridProductIds(), window.location.href);
    }

    if (window.jQuery) {
      // OptionManager fires this for every product form, so one listener covers all PDP types.
      jQuery(window).on("cc-variant-updated", function (e, args) {
        const variant = args && args.variant;
        const product = args && args.product;
        const productId =
          (product && product.id) || (data.product && data.product.id);
        if (!productId) return;

        // Switching colour or gender swaps in a different product without a
        // reload. Report the view even when no variant resolves, which happens
        // when the selected size does not exist on the incoming product.
        if (String(productId) !== String(lastProductId)) {
          trackProductView(itemPayloadFromProduct(product));
        }
        if (variant && variant.id) trackVariant(productId, variant.id);
      });

      jQuery(document).ajaxSuccess(function (event, xhr, settings) {
        const url = settings && settings.url;
        const isAdd = isCartAddUrl(url);
        if (!isAdd && !isCartMutationUrl(url)) return;
        let body = xhr && xhr.responseJSON;
        if (!body && xhr && xhr.responseText) {
          try {
            body = JSON.parse(xhr.responseText);
          } catch (err) {
            return;
          }
        }
        if (isAdd) handleCartAddResponse(body);
        else handleCartMutation(body);
      });
    }

    // Filtering, sorting and paging re-render the grid without a reload.
    const grid = productGrid();
    const isListing =
      data.pageType === "collection" || data.pageType === "search";
    if (isListing && grid && window.MutationObserver) {
      let timer = null;
      const gridObserver = new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          const href = window.location.href;
          trackCategory(
            gridProductIds(),
            data.pageType === "search" ? href : href.split("?")[0],
          );
        }, 300);
      });
      gridObserver.observe(grid, { childList: true, subtree: true });
      window.addEventListener(
        "pagehide",
        function () {
          clearTimeout(timer);
          gridObserver.disconnect();
        },
        { once: true },
      );
    }
  }

  init();
})();

function initSnapCarousel(root) {
  const track = root.querySelector('[data-carousel]');
  const bar   = root.querySelector('[data-carousel-bar]');
  const fill  = root.querySelector('[data-carousel-fill]');
  if (!track || !bar || !fill) return;

  track.scrollLeft = 0;
  requestAnimationFrame(() => { track.scrollLeft = 0; });

  const update = () => {
    const max = track.scrollWidth - track.clientWidth;
    if (max <= 0) { bar.style.display = 'none'; return; }
    bar.style.display = '';
    const ratio = track.scrollLeft / max;
    const travel = bar.offsetWidth - fill.offsetWidth;
    fill.style.transform = `translateX(${ratio * travel}px)`;
  };

  const scrubTo = (clientX, smooth = false) => {
    const { left, width } = bar.getBoundingClientRect();
    const ratio = Math.max(0, Math.min(1, (clientX - left) / width));
    const target = ratio * (track.scrollWidth - track.clientWidth);
    if (smooth) {
      track.scrollTo({ left: target, behavior: 'smooth' });
    } else {
      track.scrollLeft = target;
    }
  };

  let dragging = false;
  bar.addEventListener('pointerdown', (e) => {
    dragging = true;
    bar.setPointerCapture(e.pointerId);
    scrubTo(e.clientX, true);
  });
  bar.addEventListener('pointermove', (e) => { if (dragging) scrubTo(e.clientX); });
  bar.addEventListener('pointerup',     () => { dragging = false; });
  bar.addEventListener('pointercancel', () => { dragging = false; });

  update();
  track.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
}

$(document).ready(function() {

  // Init snap carousels — runs inside jQuery ready so DOM + CSS are guaranteed available
  document.querySelectorAll(
    'product-feature-snap, collection-feature-snap, content-cards-snap'
  ).forEach(el => initSnapCarousel(el));

  // Related products loads async via fetch — observe for item injection then init
  document.querySelectorAll('section-related-products').forEach(el => {
    const track = el.querySelector('[data-carousel]');
    if (!track) return;
    if (track.children.length > 0) {
      initSnapCarousel(el);
    } else {
      const obs = new MutationObserver((_, o) => {
        if (track.children.length > 0) {
          o.disconnect();
          setTimeout(() => initSnapCarousel(el), 150);
        }
      });
      obs.observe(track, { childList: true });
    }
  });

  const PageInits = {
    /*=== Collection Page ===================================================*/
    collection: function(a){
      var top = 0;
      var main = $(a);
      var randomClass = ( 'eH' + Math.random() ).replace('.','');
      // console.log('A random class: ' + randomClass); // ?
      main.each( function() {

        var distanceFromTop = $(this).offset().top;
        // console.log('This is ' + distanceFromTop + ' from the top.');

        if ( distanceFromTop > top ) {
          $('.' + randomClass).removeClass(randomClass);
          top = distanceFromTop;
          // console.log('"top" is ' + top + 'px away');
        }

        $(this).addClass(randomClass);

        $(this).css('min-height','auto');

        var newHeight = (Math.max.apply(null, $('.' + randomClass).map( function() {
          return $(this).outerHeight();
        }).get()));

        $('.' + randomClass).css('min-height',newHeight);

      }).removeClass(randomClass);

    }
  }


  const $navbar = $('#site-control');
  $('a[href*="#"]:not([href="#"]').on('click', function(e) {
    e.preventDefault();

    const scrollTop =
          $($(this).attr('href')).position().top -
          $navbar.outerHeight();

    $('html, body').animate({ scrollTop });
  });

  /*** Custom color select ***/
  // (function() {
  //   var $color= $('.product-nav__select-color');
  //   var $colorOption = $('.product-nav__new-select-color .tf-product-dropdown__option.enabled');
  //   var $colorSelect = $('.product-nav__new-select-color');
  //   $colorSelect.click(function() {
  //     $(this).toggleClass('open');
  //     // console.log("------------");
  //     // console.log("product nav bucket? " + $(this).parents(".product-nav-bucket").length);
  //     if ($(this).parents(".product-nav-bucket").length) {
  //       var $p = $(this).parents(".product-nav-bucket").first();
  //       // console.log("siblings buckets: " + $p.siblings(".product-nav-bucket").length);
  //       // console.log("sibling open: " + $p.siblings(".product-nav-bucket").find(".tf-product-dropdown.open").length);
  //       if ($p.siblings(".product-nav-bucket").find(".tf-product-dropdown.open").length) {
  //         // $p.siblings(".product-nav-bucket").find(".tf-product-dropdown__option-title").trigger("click");
  //         $p.siblings(".product-nav-bucket").find(".tf-product-dropdown.open").removeClass("open");
  //         // trigger creates a loop of these events, so just removing class instead;
  //       }
  //     }
  //   });
  //   $colorOption.on('click', function (e) {
  //     var optionSelectedUrl = $(this).data().url;
  //     $.getJSON(optionSelectedUrl + '.js', function(product) {
  //       window.location.replace(product.url);
  //     });
  //   });
  // })();

  /*** Custom size select ***/

  /*** disable by default, enable after picking a size ***/
  var $size = $('.product-nav__select-size');
  var $addToBagBtn = $('.add-to-bag');
  // var $addToBagForm = $('.add-to-bag');
  $size.on('change', function (e) {
    var selectedVariantId = $("option:selected", this).val();
    var selectedVariantPrice = $("option:selected", this).attr('data-productprice');
    _updateProductPrice(selectedVariantPrice);
    _updateAddToBagBtn(selectedVariantId, selectedVariantPrice);
  });
  var $sizeSelect = $('.product-nav__new-select-size');
  // var $sizeValue = $('.product-nav__new-select-size .tf-product-dropdown__option-title');
  var $sizeOption = $('.product-nav__new-select-size .tf-product-dropdown__option');
  var $lastSizeOption = null;

  $(document).on("click",".product-nav__new-select-size",function() {
    //$sizeSelect.click(function() {
    //$sizeSelect.on('click', function (e) {

    console.log("Select Size");

    $(this).toggleClass('open');
    // auto close others for PDP
    // console.log("product nav bucket? " + $(this).parents(".product-nav-bucket").length);
    if ($(this).parents(".product-nav-bucket").length) {
      var $p = $(this).parents(".product-nav-bucket").first();
      // console.log("siblings buckets: " + $p.siblings(".product-nav-bucket").length);
      // console.log("sibling open: " + $p.siblings(".product-nav-bucket").find(".tf-product-dropdown.open").length);
      if ($p.siblings(".product-nav-bucket").find(".tf-product-dropdown.open").length) {
        // $p.siblings(".product-nav-bucket").find(".tf-product-dropdown__option-title").trigger("click");
        $p.siblings(".product-nav-bucket").find(".tf-product-dropdown.open").removeClass("open");
      }
    }
  });

  $(document).on("click",".product-nav__new-select-size .tf-product-dropdown__option",function() {
    //$sizeOption.on('click', function (e) {
    console.log('slick size');
    var $el = $(this);
    var $form = $el.parents(".product-nav--actions").first().find("form"); // Sticky form
    var $sliderForm = $el.parents('form'); // Slider form
    var $oosform = $('.product-nav-waitlist');
    var data = $el.data();
    //console.log(data);
    //$('.select_size__button').hide();
    if ($lastSizeOption) {
      $lastSizeOption.removeClass('selected');
    }
    $el.addClass('selected');
    $lastSizeOption = $el;
    var selectedVariantId = data.variantId;
    var selectedVariantPrice = data.variantPrice;
    var selectedVariantStock = data.variantStock;
    var $sizeValue = $('.slick-active .product-nav__new-select-size .tf-product-dropdown__option-title');

    console.log('selectedVariantId: '+selectedVariantId);
    if (!$sizeValue.length) {
      $sizeValue = $(this).parents('.tf-product-dropdown').first().find('.tf-product-dropdown__option-title');
      var $sizeId = $(this).parents("form").first().find("[name=id]");
      $addToBagBtn = $(this).parents("form").first().find(".add-to-bag");

      if (!$sizeId.length || !$addToBagBtn.length) {
        $sizeId = $form.find("[name=id]");
        $addToBagBtn = $form.find(".add-to-bag");
      }
      $sizeId.attr("value", selectedVariantId);
      if($addToBagBtn.prop('disabled')) {
        $addToBagBtn.prop('disabled', false);
        $addToBagBtn.val("Add To Bag");
      }
    } else {
      _updateProductPrice(selectedVariantPrice);
      _updateAddToBagBtn(selectedVariantId, selectedVariantPrice);
    }
    $sizeValue.text('Size ' + $el.text());
    if($el.hasClass('outofstock') || selectedVariantStock == 0) {

      if($el.hasClass('enabled')) {

        $oosform.hide();
        $oosform.find('input').prop('disabled', true);
        $form.find('.notify-stock').hide();
        $sliderForm.find('.notify-stock').hide();
        $form.find('.add-to-bag').show();
        $sliderForm.find('.add-to-bag').show();
        $sliderForm.find('.add-to-bag').val('Add To Bag');

      } else{

        $oosform.show();
        $oosform.find('[name="out_of_stock_variant"]').val(selectedVariantId);
        $oosform.find('input').prop('disabled', false);
        $form.find('.notify-stock').show();
        $sliderForm.find('.notify-stock').show();
        $form.find('#AddToCart-new-product-template').hide();
        $sliderForm.find('#AddToCart-new-product-template').hide();
        $form.find('.add-to-bag').hide();
        //$sliderForm.find('.add-to-bag').hide();
        $sliderForm.find('.add-to-bag').val('Out Of Stock');
        $sliderForm.find('.add-to-bag').prop('disabled', true);

        // If we're using the form on the homepage slider update the notify me button URL
        if ($sliderForm.length) {
          var productURL = $sliderForm.find('[data-producturl]').attr('data-producturl') + '?variant=' + selectedVariantId + '&open_bis=true';
          $sliderForm.find('.notify-stock').attr('href', productURL);
          // console.log('productURL',productURL);
        }

      }

    } else {
      $oosform.hide();
      $oosform.find('input').prop('disabled', true);
      $form.find('.notify-stock').hide();
      $sliderForm.find('.notify-stock').hide();
      $form.find('.add-to-bag').show();
      $sliderForm.find('.add-to-bag').show();
      $sliderForm.find('.add-to-bag').val('Add To Bag');
    }

    // If we're using the form on PDP update the URL
    // console.log('slate.utils.getParameterByName("open_bis")',slate.utils.getParameterByName('open_bis'));
    if ($form.length && slate.utils.getParameterByName('open_bis') !== 'true') {
      var newurl =
          window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname +
          '?variant=' +
          selectedVariantId;
      window.history.replaceState({ path: newurl }, '', newurl);
    }
  });
  function _updateAddToBagBtn(productId, selectedVariantPrice) {
    // console.log("_updateAddToBagBtn: " + productId);
    if (!productId) {
      //console.log("no product ID");
    }
    var $addToBagInput = $('.slick-active #product-select').first();
    $addToBagInput.attr('data-productid', productId);
    $addToBagInput.attr('data-productprice', selectedVariantPrice);
    // console.log($addToBagInput, productId);
    $addToBagInput.val(productId);
    /*** disable by default, enable after picking a size ***/
    if($addToBagBtn.prop('disabled')) {
      $addToBagBtn.prop('disabled', false);
      $addToBagBtn.val("Add To Bag");
    }
  };
  function _updateProductPrice(price) {
    var $currentPriceDesktopSelector = $('#product-nav--title span').text().split('-')[0];
    var $currentPriceMobileSelector = $('#product-accordeon--mobile--product-price');
    var price = theme.Currency.formatMoney(
      price,
      theme.moneyFormat
    );
    $('#product-nav--title span').text(`${$currentPriceDesktopSelector} - ${price}`);
    $currentPriceMobileSelector.text(price);
  }
  $addToBagBtn.prop('disabled', true);


  //=== Sticky Newsletter ===//
  if($(".page-sections").length > 0){
    $(window).scroll(function(){
      var newsLetterDiv = $(".page-sections")[0].offsetTop;
      if ($(this).scrollTop() > newsLetterDiv) {
        $('.newsletter-hero__content').removeClass('sticky-newsletter');
      } else {
        $('.newsletter-hero__content').addClass('sticky-newsletter');
      }
    });
  }

  console.log("Custom.js")

  $(document).on("click", ".open-sort-by", function(e){

    $(this).parent('.cc-product-filter_button').find(`button[type="button"]:not(.open-sort-by)`).each(function(e){
      var triggerClass = "."+$(this).data("trigger");
      var triggerRemoveClass = $(this).data("triggered-class");
      if(triggerRemoveClass == undefined){
        if($(triggerClass).is(":visible")){
          $(this).removeClass("active");
          $(triggerClass).hide()
        }
      }else{
        $(triggerClass).removeClass(triggerRemoveClass);
        $(this).removeClass("active");
      }
    });

    $(this).toggleClass("active");
    if($(this).hasClass("active")){
      $(".cc-product-filter-sort-by").show()
    }
    else{
      $(".cc-product-filter-sort-by").hide()
    }

  });

  $(document).on("click", ".color-swatch__option-more", function(){
    let initalLeft = $(this).prev(".color-swatch__option-inner-container").scrollLeft();
    let slideWidth =  $(".color-swatch__option").width();
    $(this).prev(".color-swatch__option-inner-container").scrollLeft(initalLeft + slideWidth);
  });

  //Product Select Size
  $(document).on("click",".select_size",function(e) {
    e.preventDefault();
  });

  //super_here_1  super_here_1
  $(document).on("click",".super_here_1",function(e) {
    e.preventDefault();
    $('#button_section_recycle_block').click();
  });
  $(document).on("click",".super_here_2",function(e) {
    e.preventDefault();
    $('#button_section_super_block').click();
  });

  $(document).on("click",".super_here_3",function(e) {
    e.preventDefault();
    $('#button_section_pledge_block').click();
  });
  $(document).on("click",".super_here_4",function(e) {
    e.preventDefault();
    $('#button_section_super_block').click();
  });

  $(document).on("click",".super_here_5",function(e) {
    e.preventDefault();
    $('#button_section_pledge_block').click();
  });
  $(document).on("click",".super_here_6",function(e) {
    e.preventDefault();
    $('#button_section_recycle_block').click();
  });  

  //data-cc-animate-click
  $(document).on("click","#page-supercircle-by-thousand-fell [data-cc-animate-click]",function(e) {
    e.preventDefault();
    //$('#numberedcolumns').click();

    var target = $('#numberedcolumns');
    //if(target.length){
    //$('.section-hnewsletter').removeClass('opened');
    //target.addClass('opened');
    var scrollTo = target.offset().top - 73;
    $('body, html').animate({scrollTop: scrollTo+'px'}, 800);

  });

  window.onclick = function(event) {
    if (event.target == document.querySelector(".modal.collection_modal")) {
      document.querySelector(".modal.collection_modal").style.display = "none";
      $("body").removeClass("collection_modal_overlay");
    }
  }


  var swiperOptions = {
    loop: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false
    },
    slidesPerView: 'auto',
    speed: 10000,
    grabCursor: false,
    mousewheelControl: false,
    keyboardControl: false
  };

  var swiper = new Swiper(".bar.swiper-container", swiperOptions);

  $('.button-super').click(function(e){
    var target = $($(this).attr('href')),
        href = $(this).attr('href');
    if(href.includes("#")){
      e.preventDefault();
      $('.section-hnewsletter').removeClass('opened');
      target.addClass('opened');
      var scrollTo = target.offset().top - 73;
      $('body, html').animate({scrollTop: scrollTo+'px'}, 800);
    }
  });

  $(".section_close").click(function(e){
    $('.section-hnewsletter').removeClass('opened');
  })

  var quoteOptions = {
    loop: true,
    autoplay: false,
    slidesPerView: 3,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    scrollbar: false,
    breakpoints: {
      // when window width is >= 320px
      768: {
        slidesPerView: 1,
        spaceBetween: 40
      },
      // when window width is >= 640px
      1200: {
        slidesPerView: 2,
        spaceBetween: 30
      }
    }
  };

  var swiper = new Swiper(".section-testimonials .swiper-container", quoteOptions);



  //$('.product-detail__form .product-detail__form__options')

  $('.footer-button-xs .button.select_size').click(function(e){
    e.preventDefault();
    var target = $('.product-detail__form .product-detail__form__options');
    //if(target.length){
    var scrollTo = target.offset().top - 73;
    $('body, html').animate({scrollTop: scrollTo+'px'}, 800);
    // }
  });
  
  
  
  $(window).scroll(function() {
    var target = $('.view-cart-wrap');
    if (!target.length > 0) return;
    var scrollTo = target.offset().top - 73;
    var height = $(window).scrollTop();
    if (scrollTo < height) {
      $(".checkout--wrap").addClass("show_checkout");
    } else {
      $(".checkout--wrap").removeClass("show_checkout");
    }
  });


  PageInits.collection('.product-block .product-block__info > a.caption ');
  PageInits.collection('.product-block .product-block__info');

  $( window ).scroll(function() {
    PageInits.collection('.product-block .product-block__info > a.caption ');
    PageInits.collection('.product-block .product-block__info');
  });
  $( window ).resize(function() {
    PageInits.collection('.product-block .product-block__info > a.caption ');
    PageInits.collection('.product-block .product-block__info');
  });


  $(document).on("click", ".view-cart--btn:not(.checkout)", function(){
    window.location.href = "/cart";
  });

  $(document).on("click", ".clear.clear-tags", function(){
    let id = $(this).parent().find(".cc-tabs__accordion__header").attr("aria-controls");
    $(`#${id}`).find("li.active[data-tag]").find("button").click();
  });
  if($(document).find(".product-block").length){
    $(".product-block").each(function(){
//       $(this).find("form");
//       console.log($(this).find("form"));
      theme.applyAjaxToProductForm($(this).find("form"));
    })
  }
});


